//constants file
//
//MODALS
export const MODAL_FORM = "modal_form"
export const MODAL_CONFIRM = "modal_confirm"
export const MODAL_INFO = "modal_info"
export const MODAL_SETTINGS = "modal_settings"
export const MODAL_HELP = "modal_settings"
export const MODAL_WORKSPACE_MANAGER = "modal_workspace_manager"
//STATES
export const STATE_UNKNOWN = "state_unknown"
export const STATE_TODO = "state_todo"
export const STATE_WIP = "state_wip"
export const STATE_DONE = "state_done"
export const STATES = [STATE_UNKNOWN, STATE_TODO, STATE_WIP, STATE_DONE]

//COLORS
export const COLOR_DONE = "#CBE8AC"
export const COLOR_WIP  = "#FFEBC9"
export const COLOR_TODO = "#EBB5C3"
export const COLOR_UNKNOWN = "#BCBAFF"
export const COLORS = [COLOR_UNKNOWN, COLOR_TODO, COLOR_WIP, COLOR_DONE]

export const HELP = {
  'Canvas keybinds':{value:""},
  '"?"':{value:"This window."},
  '"n"':{value:"Add child node or create root if none selected."},
  '"c"':{value:"Toggle collapse of a branch."},
  '"d"':{value:"Delete selected node(s) or edge."},
  '"e" / Enter':{value:"Edit node."},
  '"s"':{value:"Select subtree."},
  '"a"':{value:"Enter edge add mode on a selected node. Escape to cancel."},
  '"u"':{value:"Undo."},
  'Arrow keys':{value:"Navigate to neighbors."},
  'Home / End':{value:"Navigate to start / end of row in tree."},
  'Shift + Left / Right':{value:"Swap with left / right neighbor."},
  'Shift + Home / End':{value:"Move to start / end of row."},
  'Space':{value:"Cycle state up."},
  'Shift + Space':{value:"Cycle state down."},
  '1-9':{value:"Directly select nodes in filter panel."},
  'PgDown / PgUp':{value:"Zoom in / out."},
  'Escapе':{value:"Clear selection."}, //TODO "e" z azbuky
  'Form keybinds':{value:""},
  'Enter':{value:"Confirm form."},
  'Shift + Enter':{value:"Newline in text area."},
  'Escape':{value:"Cancel form."},
}
